<div>
  <evsb-label *ngIf="label" [label]="label.label" [name]="name" [className]="label?.className"></evsb-label>

  <div class="flex -mx-2">
    <div *ngFor="let item of options; let i = index" class="mx-1">
      <input
        type="checkbox"
        [id]="id + '-' + i"
        [name]="name"
        [ngModel]="value[item.value]"
        (ngModelChange)="updateValueItem(item.value, !value[item.value])"
      />
      <div
        class="inline-block rounded-lg"
        [class.border-2]="!value[item.value]"
        [class.border-transparent]="!value[item.value]"
        [class.te-border-gradient-r]="value[item.value]"
      >
        <label
          [attr.for]="id + '-' + i"
          class="py-1 px-3 rounded-md cursor-pointer select-none"
          [class.bg-grey]="!value[item.value]"
          [class.text-blue-dark]="value[item.value]"
          [class.te-bg-gradient-light-r]="value[item.value]"
          >{{ item.label }}</label
        >
      </div>
    </div>
  </div>

  <evsb-error *ngIf="error" [error]="error.error" [className]="error?.className"></evsb-error>
</div>
